module.exports = "/_next/static/images/texas-cb76cdee690e0816b18ca72b2c5b341a.png";